import React, { useState, useEffect } from "react";
import { Typography, CircularProgress, Box } from "@mui/material";
import api from "../../api/api"; // Using your configured Axios instance

const GradeClassCount = () => {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClassCount();
  }, []);

  const fetchClassCount = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await api.get("grade-classes/count/", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCount(response.data.count);
    } catch (error) {
      console.error("Error fetching class count:", error);
      setCount("Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
      {loading ? (
        <CircularProgress />
      ) : (
        <Typography variant="h6" color="primary">
          Total Classes: {count}
        </Typography>
      )}
    </Box>
  );
};

export default GradeClassCount;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Typography, CircularProgress, Box } from "@mui/material";

// const GradeClassCount = () => {
//   const [count, setCount] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const token = localStorage.getItem("access");
//   useEffect(() => {
//     fetchClassCount();
//   }, []);

//   const fetchClassCount = async () => {
//     try {
//       const config = { headers: { Authorization: `Bearer ${token}` } };
//       const response = await axios.get(
//         "http://127.0.0.1:8000/grade-classes/count/",
//         config
//       );
//       setCount(response.data.count); // Extract count from API response
//     } catch (error) {
//       console.error("Error fetching class count:", error);
//       setCount("Error"); // Fallback in case of an error
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
//       {loading ? (
//         <CircularProgress />
//       ) : (
//         <Typography variant="h6" color="primary">
//           Total Classes: {count}
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default GradeClassCount;
